import { render, staticRenderFns } from "./Good.vue?vue&type=template&id=6e16ad57"
import script from "./Good.vue?vue&type=script&lang=js"
export * from "./Good.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports